<template>
  <div class="services">
    <div class="inner-content">
      <div class="intro-text">
        <p class="hey">Hey there,</p>
        <p>I'm a software engineer with 3 years of coding experience.</p>
        <p>I specialize in building full-stack web applications with Node, Express, React, Vue, and the other technologies listed below.</p>
        <p>In addition to building software, I have professional experience with marketing campaigns, SEO, and graphic design.</p>
        <p>Have a look around and feel free to get in touch!</p>
      </div>
      <IntroVideo/>
      <h3 id="services">Services</h3>
    </div>
    <SkillIcons/>      
  </div>
</template>

<script>
import SkillIcons from './SkillIcons.vue'
import IntroVideo from '../IntroVideo.vue'
export default {
  name: 'Skills',
  components: {
    IntroVideo,
    SkillIcons
  }
}
</script>

<style scoped>
.services {
  background: var(--light-grey);
  padding-bottom: 75px;
}
h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 900;
  margin: 75px auto 0 auto;
}
.inner-content {
  text-align: center;
  padding: 75px 0;
  max-width: 1000px;
  margin: auto;
}
.intro-text {
  margin: 0px auto 75px auto;
  padding: 0 20px;
  text-align: left;
  max-width: 700px;
}
.hey {
  font-size: 32px;
  margin: 0;
}
p {
  font-size: 16px;
  font-weight: 400;
  color: var(--body-text);
}
</style>
